import { FormattedMessage } from 'react-intl';
import css from './UserVerificationStatusIndicator.css';
import React from 'react';

const UserVerificationStatusIndicator = props => {
  const {
    showSteps,
    step,
    isHost,
    totalSteps,
    isVerified,
    isPending,
    isDeclined,
    isNotSubmitted,
    continueVerification,
    key
  } = props;



  const status = isVerified ? (
    <FormattedMessage id="AccountSettingDriverVerificationPage.submitted" />
  ) : isPending ? (
    <FormattedMessage id="AccountSettingDriverVerificationPage.pending" />
  ) : isDeclined ? (
    <FormattedMessage id="AccountSettingDriverVerificationPage.declined" />
  ) : (
    <FormattedMessage id="AccountSettingDriverVerificationPage.notSubmit" />
  );

  return (
    <>
      <div
        key={key}
        className={css.cardTitle}
        style={{
          borderBottom: !showSteps && '1px solid #E6E6E6',
          margin: !showSteps && '0 0 24px',
          padding: !showSteps && '0 0 20px',
        }}
      >
        <span className={css.title}>
          {isHost ? (
            'Host verification status: '
          ) : step && step.stepTitle === '' ? (
            <FormattedMessage id="AccountSettingDriverVerificationPage.status" />
          ) : (
            <FormattedMessage
              id="AccountSettingDriverVerificationPage.statusTitle"
              values={{ title: step && step.stepTitle ? step && step.stepTitle : 'Driver verification status' }}
            />
          )}{' '}
        </span>
        <span className={css.submissionStatus}>
          {!(isVerified || isPending || isDeclined) && showSteps
            ? `Step ${step.stepNum} of ${totalSteps}`
            : status}
        </span>
      </div>
      {!(isVerified || isPending || isDeclined) && continueVerification ? (
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
          {Array.from(Array(totalSteps).keys()).map(i => (
            <div
              key={i}
              style={{
                border: '4px solid',
                width: isHost ? '33.3%' : '16.6%',
                marginRight: '1px',
                borderColor:
                  i + 1 < step.stepNum ? '#fecd2a' : i + 1 === step.stepNum ? '#00a3ad' : '#E6E6E6',
              }}
            >
              {' '}
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};

export default UserVerificationStatusIndicator;
